var e = /* @__PURE__ */ ((r) => (r.SELF = "_self", r.BLANK = "_blank", r))(e || {});
export {
  e as LinkTarget
};
